import { gql } from "@apollo/client";

export const TASKS = gql`
  query Tasks(
    $where: TaskWhereInput
    $like: TaskWhereInput
    $lt: TaskWhereInput
    $gt: TaskWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    tasks(
      where: $where
      take: $take
      skip: $skip
      like: $like
      lt: $lt
      gt: $gt
      orderBy: $orderBy
    ) {
      data {
        id
        createdDate
        type
        subtype
        name
        status
        data
        result
        reminderCancelled
        campaignStep {
          id
          name
        }
        event {
          id
          startDate
        }
        project {
          id
          createdDate
          contact {
            id
            user {
              id
              firstname
              lastname
              birthDate
            }
            telecoms {
              id
              system
              value
            }
          }
          author {
            id
            firstname
            lastname
          }
        }
        createdBy {
          id
          firstname
          lastname
        }
        assignedTo {
          id
          firstname
          lastname
        }
      }
      count
    }
  }
`;

export const TASK = gql`
  query Task($where: TaskWhereInput) {
    task(where: $where) {
      id
      createdDate
      type
      subtype
      name
      status
      data
      result
      campaignStep {
        id
        name
      }
      project {
        id
        createdDate
        contact {
          id
          user {
            id
            firstname
            lastname
            birthDate
          }
          telecoms {
            id
            system
            value
          }
        }
        author {
          id
          firstname
          lastname
        }
      }
      createdBy {
        id
        firstname
        lastname
      }
      assignedTo {
        id
        firstname
        lastname
      }
    }
  }
`;

export const COUNT_TASKS = gql`
  query CountTasks(
    $where: TaskWhereInput
    $like: TaskWhereInput
    $lt: TaskWhereInput
    $gt: TaskWhereInput
  ) {
    countTasks(where: $where, like: $like, lt: $lt, gt: $gt)
  }
`;

const tasks = { TASKS, TASK, COUNT_TASKS };

export default tasks;
